// extracted by mini-css-extract-plugin
var _1 = "QXdnO__ui";
export { _1 as "ui" }
